import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

// An empty plot frame, not a loading indicator or invented return series.
export default function EmptyPerformanceChart({ label, height = 320, message = 'Load a portfolio to view performance.' }) {
    return <Box role="img" aria-label={label} sx={{ height, minWidth: 0, p: 2, pl: 5 }}>
        <Box sx={{ height: '100%', display: 'grid', placeItems: 'center', borderLeft: '1px solid', borderBottom: '1px solid', borderColor: 'divider',
            backgroundImage: (theme) => {
                const grid = alpha(theme.palette.text.secondary, 0.1);
                return `linear-gradient(to right, ${grid} 1px, transparent 1px), linear-gradient(to bottom, ${grid} 1px, transparent 1px)`;
            }, backgroundSize: '20% 25%' }}>
            <Typography variant="body2" color="text.secondary" sx={{ p: 2, textAlign: 'center' }}>{message}</Typography>
        </Box>
    </Box>;
}
